import { useId } from "react";

import { ApplicationOptionSelector } from "../../components/application";
import { useProgramScopedLocale } from "./ProgramScopedLocaleContext";

export default function ProgramScopedLocaleSelector({
  disabled = false,
  id
}) {
  const {
    isEnabled,
    activeLocale,
    supportedLocaleOptions,
    setLocale,
    translate
  } = useProgramScopedLocale();
  const generatedId = useId();
  const selectId = id || `program-scoped-locale-${generatedId}`;

  if (!isEnabled || supportedLocaleOptions.length <= 1) {
    return null;
  }

  return (
    <ApplicationOptionSelector
      id={selectId}
      label={translate("program_language", "Program language")}
      value={activeLocale}
      disabled={disabled}
      onChange={setLocale}
      options={supportedLocaleOptions.map((option) => ({
        value: option.locale,
        label: translate(option.labelKey, option.label)
      }))}
    />
  );
}
